// @flow
import * as React from 'react';
import {
  Button,
  Divider,
  IconButton,
  Popover,
  Stack,
  SxProps,
  Typography
} from '@mui/material';
import { GearSix } from '@phosphor-icons/react';
import { useContext } from 'react';
import { TableSettingsContext } from './with-table-settings';
import { TableSettingsFields } from './ui/table-settings-fields';
import { TableSettingsSaveButton } from './ui/table-settings-save-button';
import { TableViewSelect } from './ui/table-view-select';
import _ from 'lodash';
import { Tooltip } from '@coverright/ui/inputs';

type Props = {
  sx?: SxProps;
};
export const TableSettings = (props: Props) => {
  const {reset, saved, viewName, restoreFields} = useContext(TableSettingsContext);

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const viewLabel = (viewName ? _.startCase(viewName) : 'Default') + ' view';

  return (
    <Stack gap={.5} direction={'row'} alignItems={'center'} ml={2} flex={1} alignSelf={'flex-start'} sx={props.sx}>
      <Typography variant={'caption'} color={'text.secondary'}>{viewLabel}</Typography>
      <IconButton size={'small'} onClick={handleClick}>
        <GearSix />
      </IconButton>
      {!saved && <Tooltip title={'View is not saved, it will drop when you will close browser tab.'}>
        <Typography color={'secondary.500'} fontWeight={500} sx={{alignSelf: 'flex-start', ml: -.7, cursor: 'default'}}>*</Typography>
      </Tooltip>}
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Stack gap={1} minWidth={300}>
          <TableViewSelect />

          <Stack gap={2} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
            <Typography color={'text.secondary'} fontWeight={500} mx={1} mt={.5}>Fields</Typography>
            <Button size={'small'} variant={'text'} onClick={restoreFields} >
              Restore fields
            </Button>
          </Stack>
          <Divider />

          <TableSettingsFields />

          <Stack gap={2} direction={'row'} alignItems={'center'} justifyContent={'space-between'} sx={{mb: 1, mx: 1}}>
            <Button size={'small'} variant={'text'} sx={{mb: .5}} onClick={reset} color={'error'}>
              Reset view
            </Button>
            <TableSettingsSaveButton />
          </Stack>
        </Stack>


      </Popover>
    </Stack>
  );
};


